import { render, staticRenderFns } from "./ResponsavelDepartamentoRow.vue?vue&type=template&id=5d550dc5&"
import script from "./ResponsavelDepartamentoRow.vue?vue&type=script&lang=js&"
export * from "./ResponsavelDepartamentoRow.vue?vue&type=script&lang=js&"
import style0 from "./ResponsavelDepartamentoRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports